// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "header-21TeZ";
var _3 = "icon-1Nf9-";
var _4 = "success-1-iI0";
var _5 = "error-12Bvt";
var _6 = "title-1QnLz";
var _7 = "content-3BJLu";
var _8 = "description-DDVPb";
var _9 = "footer-2AMpF";
var _a = "cancel-2QMlX";
export { _1 as "__esModule", _2 as "header", _3 as "icon", _4 as "success", _5 as "error", _6 as "title", _7 as "content", _8 as "description", _9 as "footer", _a as "cancel" }
export default { "__esModule": _1, "header": _2, "icon": _3, "success": _4, "error": _5, "title": _6, "content": _7, "description": _8, "footer": _9, "cancel": _a }
